// extracted by mini-css-extract-plugin
module.exports = {"packageRow":"_1mTwGv-o","features":"_15mvsDI7","label":"_3BAlCQiy","inputStyle":"DQmCjyT3","inputSpacing":"EqsevNkm","selectSpacing":"smACTy7M"};